import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      toast.success("Connexion réussie");
      onLogin(res.data.token);
    } catch (err) {
      toast.error("Identifiants incorrects");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="w-14 h-14 bg-[#699ab6] flex items-center justify-center mx-auto mb-6">
            <Lock className="w-6 h-6 text-white" />
          </div>
          <h1 className="font-heading text-2xl font-medium text-[#333333] tracking-tight">
            Administration
          </h1>
          <p className="text-sm text-[#777] font-light mt-2">
            Connectez-vous pour accéder au panel
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-[#E5E5E5] p-8">
          <div className="mb-5">
            <label className="block text-[11px] uppercase tracking-[0.15em] text-[#777] font-medium mb-2">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#999]" />
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.ch"
                required
                className="w-full pl-10 pr-4 py-3 border border-[#E5E5E5] text-sm text-[#333] placeholder:text-[#BBB] focus:outline-none focus:border-[#699ab6] transition-colors"
              />
            </div>
          </div>

          <div className="mb-8">
            <label className="block text-[11px] uppercase tracking-[0.15em] text-[#777] font-medium mb-2">
              Mot de passe
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#999]" />
              <input
                data-testid="login-password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Votre mot de passe"
                required
                className="w-full pl-10 pr-10 py-3 border border-[#E5E5E5] text-sm text-[#333] placeholder:text-[#BBB] focus:outline-none focus:border-[#699ab6] transition-colors"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#999] hover:text-[#666]"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#699ab6] text-white py-3 text-[11px] uppercase tracking-[0.15em] font-medium hover:bg-[#5a8ba5] transition-colors disabled:opacity-50"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
